/***
 * Simple Form Javascript Validation and submit Plugin
 * handels validation and submitting a fimple form
 * 
 * usage:
 * in a simpleform template add this to the form
 * $('FORMSELECTOR').parent().ptSimpleForm({rules: sfvr})
 * rules is an object for jquery validator and are to be defined for the inputs in this very template
 * eg
 * var sfvr = {
		firstname: {
			required: true,
		},
		...
	};
 ***/	
(function ( $ ) {
 
    $.fn.ptSimpleForm = function( options ) {

      // This is the easiest way to have default options.
      var settings = $.extend({
          // These are the defaults.
          rules: {},
      }, options );
      
      var simple_formValidator;
      var wrapper = $(this);
      var ptSform = wrapper.find('form.simpleform');
     
      const buttonAction = wrapper.find('button.action');
     
      // Initialize GUI based on Rules, things that can be reused
      for (fieldname in settings.rules) {
	      const rule = settings.rules[fieldname];
	      const inputField = wrapper.find('input[name='+fieldname+']');
	      
	      // does it have datepicker class
	      
	      if (rule.ptSimpleForm_date || rule.ptSimpleForm_mindate || rule.ptSimpleForm_noWeekends) {
		      // ok, this is a date rule, init the DATE-PICKER GUI
		      
		      var dateInputOptions = {
						altFormat: "yy-mm-dd",
						dateFormat: pGetDateFormat(),
						onClose: function() {
							//make sure the datepicker is validated on date select
							inputField.valid();
				    }
					};
					
					var initDate = new Date();

					// mindate?
					if (rule.ptSimpleForm_mindate) {
						const minDate = rule.ptSimpleForm_mindate.minDate;
						if (typeof minDate == 'number') {
							dateInputOptions.minDate = "+"+minDate;
						} else {
							dateInputOptions.minDate = minDate;		
						}
					
						// the ptSimpleForm_mindate can influence initDate
						initDate = ptSimpleForm_date_calc(rule.ptSimpleForm_mindate);
					
					}
					
					// noWeekends?
				  if (rule.ptSimpleForm_noWeekends) {
						dateInputOptions.beforeShowDay = $.datepicker.noWeekends;
					}
					
					if (fieldname.endsWith("display")) {
						// give the datepicker the field without "display"
						// ie.e. set altField to "blah" when fieldname is "blahdisplay"
						var fn = fieldname.substr(0, fieldname.length-"display".length);
						dateInputOptions.altField = wrapper.find('input[name='+fn+']'); 
					}
		      
		      inputField.datepicker(dateInputOptions);
		      inputField.datepicker("setDate", initDate);
	      }
	      
	      
	      // email is implemented by replacing the rule ptSimpleForm_email with a remote rule
	      // parameters in customizedRemoteRule can be overriden.
	      if (rule.ptSimpleForm_email) {
	      	
		      if (rule.remote) {
			      throw new Error("ptSimpleForm: field "+fieldname+" cannot have both ptSimpleForm_email and remote validation");
		      }
					var customizedRemoteRule = {
						url: '/apply/verifyEmail',
						timeout: 9500,
						//if async not set as false the form submits without waiting for remote rule outcome
						//async: false,
						data : {
							language: ptCommon.language
						},
						error: function(jqXHR, textStatus, errorThrown) {
							// it failed once, it will fail again, remove the rule
							inputField.rules('remove','remote'); 
							if (simple_formValidator != null) {
								simple_formValidator.pendingRequest--;
							}
							console.log('AJAX verification error: ' + textStatus);
						},
						beforeSend: function(jqXHR, settings) {
							inputField.parent().addClass('loading');	
							buttonAction.addClass('button_loading');
							buttonAction.prop('disabled', 'disabled');
						},
						complete: function(jqXHR, textStatus) {
							inputField.parent().removeClass('loading');
							buttonAction.removeAttr('disabled');
							buttonAction.removeClass('button_loading');
						}
					}
					// overwrite customizedRemoteRule by using data from rule.ptSimpleForm_email
					$.extend(true, customizedRemoteRule, rule.ptSimpleForm_email);
		
		      settings.rules[fieldname].remote = customizedRemoteRule;
		      delete(settings.rules[fieldname].ptSimpleForm_email);
	      } 
	      
	
      }
      
			simple_formValidator = ptSform.validate({
				errorClass: "errorfield",
				validClass: "validfield",
				focusInvalid: false,
		    invalidHandler: function(form, validator) {

	        if (!validator.numberOfInvalids())
	            return;
	        
	        $('html, body').animate({
	            scrollTop: $(validator.errorList[0].element).parent().offset().top-$('.header-container').height()-20
	        }, 1000);

		    },
				onkeyup : false,
				onsubmit : true,
				onfocusout : function(element, event) {
					
					// workaround für email felder
					// diese zeile soll weg und es soll trotzdem funktionieren
					// FS#22616
					if($(element).closest('.input-box').hasClass('email')) return false;

					var val = $(element).val(); 
					val = val.trim();
					$(element).val(val);
					$(element).valid();
					
				},
				errorElement : 'span',
				errorPlacement: function(error, element) { 
						error.insertAfter(element);
							},
				showErrors: function(errorMap, errorList) {
					this.defaultShowErrors();
					// it has put the message inside the span. I want it inside the title of the span
					try {
						for ( i = 0; errorList[i]; i++ ) {
							var error = this.errorList[i];
							var label = this.errorsFor( error.element );
							label.html(error.message); // html because this is the standard set by jQuery.validate.showLabel
						}
					} catch (e) {
						console.log(e);
						if (e.stack !== undefined)
							console.log(e.stack);
					}
				},
				highlight: function(element, errorClass, validClass) {
					element = $(element);
					if (element.parent().hasClass('selector'))// unify inserts weird stuff, avoid id
						element = element.parent();
					element.addClass(errorClass).removeClass(validClass);
					element.closest('.input-box').addClass(errorClass);
					element.prev().addClass('errorlabel'); // the label left of the input
				},
				unhighlight: function(element, errorClass, validClass) {
					element = $(element);
					if (element.parent().hasClass('selector'))// unify inserts weird stuff, avoid id
						element = element.parent();
					element.removeClass(errorClass).addClass(validClass);
					element.closest('.input-box').removeClass(errorClass);
					element.prev().removeClass('errorlabel'); // the label left of the input		
			  },
				rules: settings.rules,
				submitHandler: function(form) {
					
			    buttonAction.prop('disabled', 'disabled');
					buttonAction.addClass('button_loading');
					var formData = ptSform.serializeArray();
								
				  $.ajax({
				    type: 'POST',
				    url: '/simpleForm/handleData',
				    data: formData,
				    encode: true,
				    success: function (result) {
				    	if(result) {
					    	wrapper.html(result);
					    	if(typeof window._paq != 'undefined') {
						    	_paq.push(['FormAnalytics::scanForForms']);
						    }
				    	}
					    else {
					    	console.log('//TODO: logging');
					    }
					  }
				  });
			  }

			});
				       
 
    };
 
}( jQuery ));
